import { useLocation, useNavigate } from "@remix-run/react";

import { normalizeHref } from "~/core";
import { useRootLoaderData } from "~/remix-lib";

export type MakeHrefParams = {
  pathname?: string;
  queryString?: string;
};

type NavigateToNormalizedUrlParams = {
  pathname?: string;
  queryString?: string;
};

export const useNormalizeHref = () => {
  const location = useLocation();
  const { origin, region } = useRootLoaderData();
  const navigate = useNavigate();

  return {
    /**
     * normalize된 URL을 생성합니다.
     */
    // FIXME: 쿼리스트링에서 in 쿼리 빼기
    makeHref: ({ pathname, queryString }: MakeHrefParams): string =>
      normalizeHref(`${pathname ?? location.pathname}${queryString ?? ""}`, {
        origin,
        region,
      }),
    /**
     * normalize된 URL로 이동합니다.
     * `origin`과 `region`은 현재 URL 기준으로 설정합니다.
     *
     * @param {NavigateToNormalizedUrlParams} params - pathname과 queryString을 포함한 객체.
     * @param {string} params.pathname - URL의 pathname(starts with '/') - 제공되지 않으면 location의 pathname을 사용합니다.
     * @param {string} params.queryString - URL의 query string - '?'를 포함한 형태로 제공해야 합니다.
     * @returns {void}
     */
    navigateToNormalizedUrl: ({
      pathname,
      queryString,
    }: NavigateToNormalizedUrlParams): void => {
      const href = normalizeHref(
        `${pathname ?? location.pathname}${queryString ?? ""}`,
        {
          origin,
          region,
        },
      );

      navigate(href);
    },
  };
};
